import React from "react";
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Input,
    FormLabel,
    Stack,
    FormControl,
    Icon,
} from "@chakra-ui/react";

import axios from "axios";
import { FaPencilAlt } from "react-icons/fa";

export default function ModalEditArtist(props) {
    const tokenUser = localStorage.getItem("accessToken");
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [artistData, setArtistData] = React.useState({
        artistName: props.artistName ?? "",
        firstname: props.firstname ?? "",
        lastname: props.lastname ?? "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setArtistData({
            ...artistData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const trimmedArtist = {
            artistName: artistData.artistName.trim(),
            firstname: artistData.firstname.trim(),
            lastname: artistData.lastname.trim(),
        };

        const filteredArtist = {
            artistName: trimmedArtist.artistName.length ? trimmedArtist.artistName : undefined,
            firstname: trimmedArtist.firstname.length ? trimmedArtist.firstname : undefined,
            lastname: trimmedArtist.lastname.length ? trimmedArtist.lastname : undefined,
        }

        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_URL_SERVER}/v1/artists/${props.id}`,
                filteredArtist,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json; charset=UTF-8",
                        Authorization: `Bearer ${tokenUser}`,
                    },
                }
            );
            if (response.status === 200) {
                setArtistData({
                    artistName: "",
                    firstname: "",
                    lastname: "",
                });
                onClose();
                window.location.reload();
            }
        } catch (error) {
            console.error("Erreur lors de la modification de l'artiste : ", error);
        }
    };
    return (
        <>
            <Icon
                w="20px"
                h="20px"
                me="5px"
                // color={"red.500"}
                style={{ cursor: "pointer" }}
                as={FaPencilAlt}
                onClick={onOpen}
            />
            <Modal isOpen={isOpen} onClose={onClose} size="full">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Modifier l'artiste</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <form onSubmit={handleSubmit}>
                            <Stack spacing={3} mt={5}>
                                <FormControl>
                                    <FormLabel>Nom d'artiste</FormLabel>
                                    <Input
                                        type="text"
                                        name="artistName"
                                        placeholder="Nom d'artiste"
                                        value={artistData.artistName}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Prénom</FormLabel>
                                    <Input
                                        type="text"
                                        name="firstname"
                                        placeholder="Prénom"
                                        value={artistData.firstname}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Nom de famille</FormLabel>
                                    <Input
                                        type="text"
                                        name="lastname"
                                        placeholder="Nom de famille"
                                        value={artistData.lastname}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                            </Stack>
                        </form>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme="red" mr={3} onClick={onClose}>
                            Annuler
                        </Button>
                        <Button colorScheme="blue" onClick={handleSubmit}>
                            Mettre à jour l'artiste
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};
